module.exports = __webpack_public_path__ + "static/media/vacctrak-supports.db21bf2a.png";